import React from 'react';

const JudgmentStatistics = ({
  stats,
}: {
  stats: {
    total: number;
    totalEvaluations: number;
    averageScore: number;
  };
}) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    <div className="bg-white rounded-xl p-6 text-center shadow-md border border-gray-100">
      <div className="text-3xl font-bai font-bold text-gray-900">
        {stats.total}
      </div>
      <div className="text-sm text-gray-600 font-bai mt-1">
        Total Submissions
      </div>
    </div>
    <div className="bg-white rounded-xl p-6 text-center shadow-md border border-gray-100">
      <div className="text-3xl font-bai font-bold text-amber-600">
        {stats.totalEvaluations}
      </div>
      <div className="text-sm text-gray-600 font-bai mt-1">
        Total Evaluation
      </div>
    </div>
    <div className="bg-white rounded-xl p-6 text-center shadow-md border border-gray-100">
      <div className="text-3xl font-bai font-bold text-blue-600">
        {stats.averageScore}
      </div>
      <div className="text-sm text-gray-600 font-bai mt-1">Average Score</div>
    </div>
  </div>
);

export default JudgmentStatistics;
